import HeaderbarHome from "../HeaderbarHome/HeaderbarHome";
import Sidebar from "../Sidebar/Sidebar";
import { ContainerChildren, ContainerContent, ContainerLayout } from "./localStyle";

const Layout = ({ children }) => {
    const onShowBurguerHandle = () => {
        // setShowBurguerMobile(true);
    };
    
    
  return (
    <ContainerLayout>
        <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <ContainerContent>
       <Sidebar  />
        <ContainerChildren>
            {children}
        </ContainerChildren>
      </ContainerContent>
    </ContainerLayout>
  );
};

export default Layout;
